import { axios } from "~/plugins/request";

export const state = () => {
  return {};
};
export const mutations = {};
export const actions = {
  getUserBindInfo({ commit }) {
    return new Promise((resolve, reject) => {
      axios
        .get(`yunBind/getUserBindInfo`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  changeBindStep({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .get(`yunBind/changeBindStep`, { params })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  applyBindBankCard({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post(`yunBind/applyBindBankCard`, params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  setCompanyInfo({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post(`yunBind/setCompanyInfo`, params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  signContract({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .get(`yunBind/signContract`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  setRealName({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .get(`yunBind/setRealName`, { params })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  sendVerificationCode({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .get(`yunBind/sendVerificationCode`, { params })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  bindPhone({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .get(`yunBind/bindPhone`, { params })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getOrgInfo({ commit }) {
    return new Promise((resolve, reject) => {
      axios
        .get(`yunBind/getOrgInfo`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  applyNewBindBankCard({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post(`yunBind/applyNewBindBankCard`, params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getAllBindCard({ commit }) {
    return new Promise((resolve, reject) => {
      axios
        .get(`yunBind/getAllBindCard`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  unbindBankCard({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .get(`yunBind/unbindBankCard`, { params })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  }
};
